module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2XO7e"))).then(() => parcelRequire('hEqeo'));